import z from 'zod';
export const LAWYER_CONSULTATION = 'lawyer-consultation';
export const REQUEST_QUOTE = 'request-quote';
export const SUGGEST_DOCUMENT = 'suggest-document';
export const PARTNERS_REQUEST_TYPES = {
    LAWYER_CONSULTATION: LAWYER_CONSULTATION,
    REQUEST_QUOTE: REQUEST_QUOTE,
    SUGGEST_DOCUMENT: SUGGEST_DOCUMENT,
};
export const partnersRequestTypeValue = z.enum([
    LAWYER_CONSULTATION,
    REQUEST_QUOTE,
    SUGGEST_DOCUMENT,
]);
export const partnersRequestType = (value) => partnersRequestTypeValue.parse(value);
export const isPartnersRequestType = (value) => partnersRequestTypeValue.safeParse(value).success;
//# sourceMappingURL=partnersRequestTypeContants.js.map